import { SchemaElementTypes, } from "../../interfaces/store/actions/payload/schema/schemaElements";
import { checkTranslation, formatString, isFieldEmpty, isVisibleConditionalField, validateComparisonConstraints, validateOptionalGeometryField, validateOptionalNumericField, } from "../common";
import { getComparisonItems, isRepeatable } from "./schemaUtils";
import { VALIDATION_TRANSLATE_PATH } from "../constants";
export var validateField = function (value, element, translate, comparisonItems) {
    var error;
    var translationId;
    var fallbackTranslation;
    var fieldTranslatePath = VALIDATION_TRANSLATE_PATH + "." + element.fieldName;
    var optionalFallbackTranslation = VALIDATION_TRANSLATE_PATH + "._optional.text";
    if (element) {
        switch (element.schemaType) {
            case SchemaElementTypes.STRING_TYPE: {
                var _a = element, optional = _a.optional, multiValue = _a.multiValue, forbiddenCharacters_1 = _a.forbiddenCharacters, regex = _a.regex, regexDescription = _a.regexDescription;
                if (optional === false) {
                    fallbackTranslation = translate(optionalFallbackTranslation);
                    translationId = fieldTranslatePath + ".optional.text";
                    error = isFieldEmpty(value, multiValue, translationId, fallbackTranslation, translate);
                    if (comparisonItems) {
                        error = validateComparisonConstraints({
                            value: value,
                            comparisonItems: comparisonItems,
                            fieldTranslatePath: fieldTranslatePath,
                            translate: translate
                        });
                    }
                }
                if (forbiddenCharacters_1) {
                    forbiddenCharacters_1.forEach(function (char) {
                        if (value && value.includes(char)) {
                            var forbiddenCharactersFallbackTranslation = "_configurableValidation._forbiddenCharacters.text";
                            fallbackTranslation = translate(forbiddenCharactersFallbackTranslation);
                            translationId = fieldTranslatePath + ".forbiddenCharacters.text";
                            error = formatString(checkTranslation(translationId, forbiddenCharactersFallbackTranslation, translate), forbiddenCharacters_1.join(","));
                        }
                    });
                }
                if (regex) {
                    var matcher = new RegExp(regex, "g");
                    if (value && !matcher.test(value)) {
                        translationId = fieldTranslatePath + ".regexDescription.text";
                        var translation = translate(translationId);
                        var useFallback = translation.startsWith("_error_");
                        if (useFallback) {
                            var regexDescriptionFallbackTranslation = "_configurableValidation._regexDescription.text";
                            fallbackTranslation = translate(regexDescriptionFallbackTranslation);
                            translation = translation.startsWith("_error_") ? regexDescription : fallbackTranslation;
                        }
                        error = checkTranslation(translationId, translation, translate);
                    }
                }
                break;
            }
            case SchemaElementTypes.INTEGER_TYPE: {
                var optional = element.optional;
                error = validateOptionalNumericField({
                    optional: optional,
                    value: parseInt(value, 10),
                    optionalFallbackTranslation: optionalFallbackTranslation,
                    fieldTranslatePath: fieldTranslatePath,
                    translate: translate,
                });
                if (!error && comparisonItems) {
                    error = validateComparisonConstraints({
                        value: value,
                        comparisonItems: comparisonItems,
                        fieldTranslatePath: fieldTranslatePath,
                        translate: translate
                    });
                }
                break;
            }
            case SchemaElementTypes.FLOAT_TYPE: {
                var optional = element.optional;
                error = validateOptionalNumericField({
                    optional: optional,
                    value: parseFloat(value),
                    optionalFallbackTranslation: optionalFallbackTranslation,
                    fieldTranslatePath: fieldTranslatePath,
                    translate: translate,
                });
                if (comparisonItems) {
                    error = validateComparisonConstraints({
                        value: value,
                        comparisonItems: comparisonItems,
                        fieldTranslatePath: fieldTranslatePath,
                        translate: translate
                    });
                }
                break;
            }
            case SchemaElementTypes.TIMEPOINT_TYPE: {
                var optional = element.optional;
                error = validateOptionalNumericField({
                    optional: optional,
                    value: parseInt(value, 10),
                    optionalFallbackTranslation: optionalFallbackTranslation,
                    fieldTranslatePath: fieldTranslatePath,
                    translate: translate,
                });
                if (comparisonItems) {
                    error = validateComparisonConstraints({
                        value: value,
                        comparisonItems: comparisonItems,
                        fieldTranslatePath: fieldTranslatePath,
                        translate: translate
                    });
                }
                break;
            }
            case SchemaElementTypes.GEOMETRY_TYPE: {
                var optional = element.optional;
                if (optional === false && Array.isArray(value)) {
                    error = validateOptionalGeometryField({
                        optional: optional,
                        value: value,
                        optionalFallbackTranslation: optionalFallbackTranslation,
                        fieldTranslatePath: fieldTranslatePath,
                        translate: translate,
                    });
                    if (comparisonItems) {
                        error = validateComparisonConstraints({
                            value: value,
                            comparisonItems: comparisonItems,
                            fieldTranslatePath: fieldTranslatePath,
                            translate: translate
                        });
                    }
                }
                break;
            }
            case SchemaElementTypes.BOOLEAN_TYPE: {
                if (comparisonItems) {
                    var optional = element.optional;
                    error = validateComparisonConstraints({
                        value: optional ? value : !!value,
                        comparisonItems: comparisonItems,
                        fieldTranslatePath: fieldTranslatePath,
                        translate: translate
                    });
                }
                break;
            }
            default:
                break;
        }
    }
    return error;
};
export var processFieldValidation = function (data, element, translate, segmentId) {
    var errorList = [];
    var value = data[segmentId + "_" + element.fieldName] === undefined
        ? data[element.fieldName] : data[segmentId + "_" + element.fieldName];
    var isRepeatableField = isRepeatable(element);
    var allValues = isRepeatableField && Array.isArray(value) ? value : [value];
    var comparisonItems = getComparisonItems(element, data, segmentId);
    allValues.forEach(function (currentValue, idx) {
        var error = validateField(currentValue, element, translate, comparisonItems);
        if (error) {
            errorList.push({
                name: segmentId ? segmentId + "_" + element.fieldName : element.fieldName,
                error: error,
                repeatableIdx: isRepeatableField ? idx : undefined,
            });
        }
    });
    return errorList;
};
var shouldBeIgnoredByValidation = function (element, referenceName) {
    var _a;
    var ignoreValidation = false;
    if (element.schemaType === SchemaElementTypes.STRING_TYPE) {
        var stringElement = element;
        ignoreValidation = (stringElement.injectionReference !== undefined
            && stringElement.injectionReference === referenceName)
            || (!!((_a = stringElement.fallbackReferences) === null || _a === void 0 ? void 0 : _a.length)
                && stringElement.fallbackReferences.includes(referenceName));
    }
    return ignoreValidation;
};
export var validateFieldReferences = function (data, element, translate, segmentId) {
    var errorList = [];
    var refElements = element.refElements;
    if (refElements && Object.values(refElements).length) {
        var elementsVisible = true;
        if (element.schemaType === SchemaElementTypes.CONDITIONAL_TYPE) {
            var _a = element, whenReference = _a.whenReference, anyOf = _a.anyOf;
            var anyOfValues = anyOf || [];
            elementsVisible = isVisibleConditionalField({
                fieldName: segmentId + "_" + whenReference, whenReference: whenReference, anyOfValues: anyOfValues, value: data, element: element,
            });
        }
        if (elementsVisible) {
            Object.values(refElements).forEach(function (fieldElement) {
                if (!shouldBeIgnoredByValidation(element, fieldElement.fieldName)) {
                    errorList = errorList.concat(validateFieldReferences(data, fieldElement, translate, segmentId));
                }
            });
        }
    }
    errorList = errorList.concat(processFieldValidation(data, element, translate, segmentId));
    return errorList;
};
